module.exports = __webpack_public_path__ + "static/stefanie-2d6720926a5f5e4ddac6263812623ae1.jpg";